export default "__VITE_ASSET__BqUx2tzD__"